export const formatSettings = () => {
    return [
        { rename : 'description', name: 'configuration'},
        { rename : 'value', name: 'value'}
    ];
}